const ExternalScriptsEnum = {
  Translodit: {
    src:
      'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/scripts/lazyLoaded/transloadit.js',
    id: 'translodit'
  },
  AzureMediaPlayer: {
    src: '//amp.azure.net/libs/amp/2.3.2/azuremediaplayer.min.js',
    id: 'azuremediaplayer'
  },
  WistiaPlayer: {
    // src:
    //   'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/scripts/lazyLoaded/wistiaPlayer-new.min.js',
    // src: 'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/scripts/lazyLoaded/wistiaPlayer-1.min.js',
    // src:
    //   'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/scripts/lazyLoaded/wistiaPlayer-2.min.js',
    src: 'https://fast.wistia.com/assets/external/E-v1.js',
    id: 'wistiaplayer'
  }
};

export { ExternalScriptsEnum };
